module.exports = $bonelibs.React;


//////////////////
// WEBPACK FOOTER
// external "$bonelibs.React"
// module id = 0
// module chunks = 1 3 4 5 6 7 8 9 10 15 18